





































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { Apis, Factories } from '@finx/web-repository'
import _ from 'lodash'
import { Loading } from '@/types/_'

@Component

export default class ComponentDialogProcedimentoSearch extends Vue {
  @Prop(Array) data
  @Prop(String) placeholder
  @Prop(Array) properties
  @Prop(Boolean) show
  @Prop(Number) tabelaId
  @Prop(Number) porteId

  typing: Boolean = false
  search: String = ''
  selecteds: any[] = []
  procedimentosListTemp: Array<any> = []

  get procedimentosList() {
    return this.procedimentosListTemp
  }

  set procedimentosList(value) {
    this.procedimentosListTemp = value
  }

  get getSearch() {
    return this.search
  }

  set getSearch(value) {
    this.search = value
  }

  @Watch('show')
  watchShow() {
    this.toggleBodyOverflow()
    this.getProcedimentos(null)
  }

  @Emit('close')
  hide() {
    this.search = ''
  }

  debounce = _.debounce(param => this.getProcedimentos(param), 700)

  async runSearch(param) {
    if (param.length > 2) {
      await this.debounce(param)
    }
  }

  @Emit('selected')
  selected(item, index) {
    this.hide()
  }

  toggleBodyOverflow() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html) html.classList.toggle(noOverflowClass)
  }

  async getProcedimentos(search) {
    this.typing = true
    this.procedimentosList = []

    if (this.tabelaId && this.porteId) {
      const request = await Apis.Legacy
        .Procedimentos.getProcedimentosMinificados(this.tabelaId, this.porteId, search)
      const success = Factories.Apis.success(request)

      if (success) {
        this.procedimentosList = request.data
      }
    }

    this.typing = false
  }
}

